export const SKILL_CATEGORIES = [
  ['digital', 'Digital Skills'], ['trade', 'Trade Skills'], ['healthcare', 'Healthcare Skills'],
  ['business', 'Business Skills'], ['creative', 'Creative Skills'], ['language', 'Language Skills'],
  ['soft', 'Soft Skills'], ['life', 'Life Skills'], ['other', 'Other']
].map(([id, label]) => ({ id, label }));

const labels = Object.fromEntries(SKILL_CATEGORIES.map(category => [category.id, category.label]));
const aliases = Object.fromEntries(SKILL_CATEGORIES.flatMap(category => [
  [category.id, category.id], [category.label.toLowerCase(), category.id]
]));
const tradeTerms = ['motor mechanic', 'automotive', 'electric', 'plumb', 'boilermak', 'brick',
  'masonry', 'weld', 'carpent', 'construction', 'roofing', 'tiling', 'house painting',
  'painting and decorating', 'millwright', 'fitter', 'machining', 'diesel mechanic', 'refrigeration',
  'forklift', 'reach truck'];

export const canonicalSkillCategory = (category, name = '') => {
  const key = String(category || '').trim().toLowerCase();
  const skillName = String(name).trim().toLowerCase();
  if (['technical', 'technical skills', 'trade', 'trade skills'].includes(key) &&
      ['basic first aid', 'food safety & hygiene', 'health & safety awareness'].includes(skillName)) return 'healthcare';
  if (['technical', 'technical skills'].includes(key)) return tradeTerms.some(term => skillName.includes(term)) ? 'trade' : 'digital';
  return aliases[key] || ({ communication: 'soft', operations: 'business', employability: 'soft' }[key]) || 'other';
};

export const skillCategoryLabel = (category, name) => labels[canonicalSkillCategory(category, name)];

export const lmsSkillCategoryKey = (skillOrCategory) => {
  const value = typeof skillOrCategory === 'object'
    ? (skillOrCategory?.lms_category || skillOrCategory?.skill_lms_category || skillOrCategory?.category)
    : skillOrCategory;
  return String(value || 'other').trim().toLowerCase();
};

export const lmsSkillCategoryLabel = (skillOrCategory) =>
  lmsSkillCategoryKey(skillOrCategory).replace(/[_-]+/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());

export const lmsSkillCategoryOptions = (catalogue = []) => {
  const categories = new Map();
  catalogue.forEach(skill => {
    const key = lmsSkillCategoryKey(skill);
    if (key && !categories.has(key)) categories.set(key, lmsSkillCategoryLabel(key));
  });
  return Array.from(categories, ([id, label]) => ({ id, label }))
    .sort((first, second) => first.label.localeCompare(second.label));
};

export const availableCatalogueSkills = (catalogue, ownedSkills) => {
  const ownedIds = new Set(ownedSkills.map(skill => String(skill.skill?.id ?? skill.skill)));
  return catalogue.filter(skill => skill.is_active !== false && !ownedIds.has(String(skill.id)));
};

export const filterCatalogueSkills = (catalogue, search, category) => {
  const query = search.trim().toLowerCase();
  return catalogue.filter(skill => (!category || lmsSkillCategoryKey(skill) === category) &&
    (!query || skill.name.toLowerCase().includes(query)));
};
